import { compose, setDisplayName } from 'recompose';

const enhance = compose(setDisplayName('CommonRoutes'));

export default enhance;
